import $ from 'jquery';
// import '../../../../../bower_components/slick-carousel/slick/slick';
import 'slick-carousel';
import './slider-diapo-fiche-vehicule';

$(document).ready(function () {
    $('.sliderThumb').on('init', function () {
        $('.sliderThumb').css('visibility', 'visible').css('height', $('.sliderDiapo').outerHeight() - 20);
    }).not('.slick-initialized').slick({
        cssEase: 'ease-in-out',
        infinite: true,
        autoplay: false,
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 3,
        // slidesToScroll: 3,
        asNavFor: '.sliderDiapo',
        focusOnSelect: true,
        pauseOnHover: true,
        lazyLoad: 'progressive'
    });
});

$(window).resize(function () {
    $('.sliderThumb').css('height', $('.sliderDiapo').outerHeight() - 20);
});
